import { Icon } from "antd"
import * as React from "react"
import { ThemeType } from "antd/lib/icon"

type Props = {
    className?: string
    style?: React.CSSProperties
    theme?: ThemeType
    type: string
    onClick?: (e: React.MouseEvent<HTMLElement>) => void
    role?: string
    spin?: boolean
}
/** Wrapper for rendering antd icons (https://3x.ant.design/components/icon/) */
export const AntdIconWrap = (props: Props) => {
    // For some reason or bad antd types, typescript is screaming when using this <Icon component
    // TS2604: JSX element type 'Icon' does not have any construct or call signatures.
    // @ts-expect-error - antd v3 legacy issue.
    return <Icon {...props} />
}
